import { SEO_COMING_SOON_MODE, SEO_FULL_MODE } from '../seo/seoMetadata.js';
import {
  MARKETING_VERSION_V1,
  MARKETING_VERSION_V2,
  MARKETING_VERSION_V3,
  resolveMarketingVersion,
} from './marketingVersion.js';

export const LANDING_VARIANT_COMING_SOON = SEO_COMING_SOON_MODE;
export const LANDING_VARIANT_V1 = MARKETING_VERSION_V1;
export const LANDING_VARIANT_V2 = MARKETING_VERSION_V2;
export const LANDING_VARIANT_V3 = MARKETING_VERSION_V3;

export function resolveFullModeLandingVariant({
  siteMode = SEO_FULL_MODE,
  marketingVersion = MARKETING_VERSION_V1,
} = {}) {
  const normalizedMode = String(siteMode || '').trim().toLowerCase();
  if (normalizedMode === SEO_COMING_SOON_MODE) {
    return LANDING_VARIANT_COMING_SOON;
  }

  const resolvedVersion = resolveMarketingVersion(marketingVersion);
  if (resolvedVersion === MARKETING_VERSION_V2) {
    return LANDING_VARIANT_V2;
  }

  if (resolvedVersion === MARKETING_VERSION_V3) {
    return LANDING_VARIANT_V3;
  }

  return LANDING_VARIANT_V1;
}
